var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutMenuicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36133 1.75378H18.3736V18.8737C18.3736 19.7641 17.3513 20.2666 16.6463 19.7228L15.2192 18.6219C14.8602 18.345 14.3658 18.3237 13.9844 18.5689L12.0272 19.8272C11.3207 20.2813 10.4142 20.2813 9.70774 19.8272L7.75048 18.5689C7.36907 18.3237 6.87466 18.345 6.51565 18.6219L5.0886 19.7228C4.38364 20.2666 3.36133 19.7641 3.36133 18.8737V1.75378Z",
    stroke: "#434343",
    strokeWidth: 1.60845
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65039 8.18703H10.8673",
    stroke: "#434343",
    strokeWidth: 1.60845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2168 1.7538H20.5183",
    stroke: "#434343",
    strokeWidth: 1.60845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65039 12.4758H10.8673",
    stroke: "#434343",
    strokeWidth: 1.60845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.084 8.18703H14.6201",
    stroke: "#434343",
    strokeWidth: 1.60845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.084 12.4758H14.6201",
    stroke: "#434343",
    strokeWidth: 1.60845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutMenuicon);
export default __webpack_public_path__ + "static/media/about_menuicon.9b53049ba1d92ef54fb87e068716f625.svg";
export { ForwardRef as ReactComponent };